import * as styles from '../utils/tooltip-styles.sty.js';

export interface BodyRow {
  axisId: string;
  text: string;
  duration?: string;
}

export function BodyRow({ axisId, text, duration }: Readonly<BodyRow>) {
  return (
    <div className={styles.wrapper}>
      <span className={styles.axisName}>{`${axisId}:`}</span>
      <span className={styles.axisValue}>{text}&nbsp;</span>
      {duration ? (
        <span className={styles.duration}>{`(${duration})`}</span>
      ) : null}
    </div>
  );
}

BodyRow['displayName'] = 'BodyRow';
